const ITEMS = [
  "Marabou Design",
  "Drop 004",
  "Heavyweight 280GSM",
  "Archival Prints",
  "Organic Cotton",
  "Zero-Waste Ink",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-[#E4E4DE] py-5 bg-[#F7F7F2]">
      <div className="flex w-max animate-marquee items-center gap-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span
              className={`font-display text-3xl sm:text-5xl font-extrabold uppercase tracking-tighter whitespace-nowrap ${
                i % 2 === 0 ? "text-outline" : "text-[#4D7C0F]"
              }`}
            >
              {item}
            </span>
            <span className="h-2 w-2 rotate-45 bg-[#141412]" />
          </span>
        ))}
      </div>
    </div>
  );
};
